export const MOBILE_WIDTH = 345;
export const DESKTOP_WIDTH = 832;
